module.exports = __webpack_public_path__ + "img/quiz_bg_02.d44c85c1.png";